import { clearStorageRetainCookies } from './storageHelper';

// Oturum gerektirmeyen sayfalar; buralarda korumalı bir istek 401 alsa bile
// kullanıcıyı login'e zorlama (login, şifremi unuttum vb. kendi hatasını yönetir).
const PUBLIC_PATHS = [
  "/login",
  "/signUp",
  "/passwordReset",
  "/setNewPassword",
  "/twoFactor",
  "/cerez-politikasi",
];

export const isPublicPath = (pathname = window.location.pathname) =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));

export const hasStoredSession = () => Boolean(localStorage.getItem("token"));

/**
 * Oturumu sonlandırıp login'e götürür. Tam sayfa yenileme (replace) yapılır ki
 * redux-persist'teki bellek içi "authenticated" durumu da sıfırlansın; aksi
 * halde SPA açık kalır, her istek 401 alır ve ekranlar boş görünür.
 */
export const redirectToLogin = ({ clear = true } = {}) => {
  // Public sayfada (login, 2FA, şifre belirleme) zaten oturum yok; storage'ı
  // temizlemek o akışın ara verisini (ör. username) silerdi — dokunma.
  if (isPublicPath()) {
    return;
  }
  if (clear) {
    clearStorageRetainCookies();
  }
  window.location.replace("/login");
};

/**
 * Başka bir sekmede oturum kapatılır ya da storage temizlenirse bu sekmeyi de
 * login'e götür. `storage` event'i yalnızca DİĞER sekmelerde tetiklenir;
 * localStorage.clear() key=null ile, doğrudan silme key="token" ile gelir.
 */
export const startCrossTabSessionSync = () => {
  window.addEventListener("storage", (event) => {
    const sessionKeyTouched = event.key === null || event.key === "token";
    if (sessionKeyTouched && !hasStoredSession() && !isPublicPath()) {
      window.location.replace("/login");
    }
  });
};
